import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { ServicePlan } from 'src/features/servicePlans/utils/types';
import { servicePlansMessages } from 'src/features/servicePlans/utils/messages';
import { useCreateServicePlan } from 'src/features/servicePlans/api/useCreateServicePlan';
import { LIST_SERVICE_PLANS_RESOURCE } from 'src/features/servicePlans/api/useListServicePlans';
import ServicePlanFormModal from 'src/features/servicePlans/components/forms/ServicePlanFormModal';

interface CreateServicePlanFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlan?: ServicePlan;
    children?: React.ReactNode;
}

function CreateServicePlanFormModal<TData>({ className, semantics }: CreateServicePlanFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateServicePlan({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLANS_RESOURCE] });
            toast({
                title: formatMessage(servicePlansMessages.createServicePlanSuccess),
                description: formatMessage(servicePlansMessages.createServicePlanSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <ServicePlanFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(servicePlansMessages.addServicePlanSubtitle)}
        />
    );
}

export default CreateServicePlanFormModal;
